import React from 'react';
import FlujoFondos from './FlujoFondos';

export default function FlujoFondosCalendarioPage() {
  return <FlujoFondos initialSection="calendario" />;
}
